export default __webpack_public_path__ + "static/media/logo-myhealthcare-doctor.98045e4d.svg";